
import {
    FaMoneyBillTrendUp,
    FaDollarSign,
    FaListCheck,
    FaWrench,
    FaBolt,
    FaUserCheck,
    FaMoneyBillWave,
    FaShieldHalved,
} from "react-icons/fa6";



export const benefitsData = [
    {
        title: "In-House Billing and Revenue Generation",
        description:
            "Bring diagnostic lab services in-house to manage billing directly, retain reimbursements, and create an additional revenue stream for your practice.",
        icon: FaMoneyBillTrendUp,
    },
    {
        title: "No Initial Costs",
        description:
            "Start your lab services without major upfront costs for equipment, staffing, or setup. MITSI provides a fully equipped lab solution.",
        icon: FaDollarSign,
    },
    {
        title: "We Handle Everything",
        description:
            "MITSI manages lab setup, equipment, supplies, staff training, and certification support, making the entire process simple and efficient.",
        icon: FaListCheck,
    },
    {
        title: "Hassle-Free Maintenance",
        description:
            "MITSI handles equipment, inventory, and lab operations so your team can spend less time managing the lab and more time focusing on patient care.",
        icon: FaWrench,
    },
];

export const stepper = [
    {
        icon: <FaBolt />,
        title: "Fast Turnaround",
        description:
            "An in-house lab gives patients quicker results. This builds up satisfaction and trust.",
        align: "bottom",
    },
    {
        icon: <FaUserCheck />,
        title: "Improved Patient Experience",
        description:
            "Keep tests close to home. It will reduce the risk of delays with third-party labs.",
        align: "top",
    },
    {
        icon: <FaMoneyBillWave />,
        title: "Cost Savings",
        description:
            "Cut expensive technician salaries, inventory, and equipment repairs.",
        align: "bottom",
        featured: true,
    },
    {
        icon: <FaShieldHalved />,
        title: "Regular Compliance",
        description:
            "Your lab meets all industry standards and guidelines. You can rest easy.",
        align: "top",
    },
];